import {
  FactoryProvider,
  InjectionToken, StaticProvider,
} from '@angular/core'
import { LogSink } from '../services/logger.service'

export type LoggerSinks = { [name: string]: LogSink }

export const LOGGER_SINKS = new InjectionToken<LoggerSinks>('logger:SINKS')
export function provideLoggerSinks(sinks: LoggerSinks): StaticProvider {
  return {
    provide: LOGGER_SINKS,
    useValue: sinks,
  }
}
export function provideLoggerSinksFactory(sinksFactory: (...args: unknown[]) => LoggerSinks | null | undefined, deps: unknown[]): FactoryProvider {
  return {
    provide: LOGGER_SINKS,
    useFactory: sinksFactory,
    deps: deps,
  }
}
